import IntroductionIndicator from './IntroductionIndicator';

export default IntroductionIndicator;
